globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Controllers = appCustomerSpace.Controllers || {};
appCustomerSpace.Controllers.Public = appCustomerSpace.Controllers.Public || {};

appCustomerSpace.Controllers.Public.WelcomeNewAccountFunnelController = (function(superClass) {

    utils.extend(MainController, superClass);

    function MainController() {
        this.$html      = $('body.welcome-funnel');
        this.$form      = this.$html.find("form");
        this.$submitBtn = this.$form.find('.panel-footer button[type="submit"]');
        return MainController.__super__.constructor.apply(this, arguments);
    }

    $.extend(MainController.prototype, {
        init: function() {
            return MainController.__super__.init.apply(this, arguments);
        },
        offers: function() {
            var _this = this;
            _this.$pricingTogglers          = _this.$html.find('input[data-pricing-targets]');
            _this.$togglerWebsite           = _this.$html.find('#customer_space_public_welcome_funnel_offers_step_form_website_deal_included');
            _this.$togglerLocalManagement   = _this.$html.find('#customer_space_public_welcome_funnel_offers_step_form_local_management_deal_included');
            _this.$pagesSliderInput         = _this.$html.find('input[name="website_deal_slider_pages_count"]');
            _this.$pagesSliderHiddenInput   = _this.$html.find('input[name="customer_space_public_welcome_funnel_offers_step_form[website_deal_feature_additional_pages_count]"]');
            _this.$radioZones               = _this.$html.find(".radio-zone");
            _this.$pagesCard                = _this.$html.find(".radio-zone.pages-zone");
            _this.$pagesCardPagesCount      = _this.$pagesCard.find(".website-pages-count");
            _this.$pagesCardReccuringPrice  = _this.$pagesCard.find(".website-prices.website-pages-recurring-price");
            _this.$pagesCardOneOffPrice     = _this.$pagesCard.find(".website-pages-one-off-price");
            _this.$pagesPackInfo            = _this.$html.find(".pack-pages-info");
            _this.$baseBacksInputs          = _this.$html.find('input[name="customer_space_public_welcome_funnel_offers_step_form[website_deal_base_pack_service_item_key]"]');

            _this.offerSetCardsHover();
            _this.offersRefreshAllCardsPrices();
            _this.offersEvents();
            _this.offersSetPagesInputsValues();
            _this.offersRefreshPagesCard();
            _this.offersPagesEvents();
        },
        migration: function() {
            var _this = this;
            _this.$consentCheckbox  = _this.$html.find('input[name="migration_step[migration_consent]"]');
            _this.migrationEvents();
        },
        payment: function() {
            var _this = this;
            _this.$iframeContainer  = _this.$html.find("#iframe-container");
            _this.iframeOrigin      = _this.$iframeContainer.find("iframe").data("origin");
            _this.$wizardProgress   = _this.$html.find('.step.current .progress-bar');
            _this.$submitBtn        = _this.$html.find(".panel-footer a");
            _this.paymentEvents();
        },
        summary: function() {
            var _this = this;
            _this.$summaryForm              = _this.$html.find('form.new_customer_space_public_welcome_funnel_summary_step_form');
            _this.$consentCheckbox          = _this.$html.find('input[name="customer_space_public_welcome_funnel_summary_step_form[set_deals_as_won]"]');
            _this.$numberInputs             = _this.$html.find('input[type="number"]');
            _this.$discountRefreshButtons   = _this.$html.find('button.refresh-discounts');
            _this.$selectBusinessVoucher    = _this.$html.find(".percentage-form-group select");
            _this.summaryEvents();
        },
        // OFFERS FUNCTIONS
        offersEvents: function() {
            var _this = this;

            _this.$form.on("submit", function(event) {
                _this.displaySubmitLoader();
            });

            _this.$togglerWebsite.add(_this.$togglerLocalManagement).on("change", function() {
                _this.toggleSubmitDisabled(_this.$togglerLocalManagement.is(":checked") || _this.$togglerWebsite.is(":checked"));
            });

            _this.$baseBacksInputs.on("change", function() {
                if($(this).is(":checked")) { _this.offersSetBasePackPages($(this)); }
            });

            _this.$pricingTogglers.on("change", function() {
                if($(this).is(":checked")) { _this.offersPricingTogglersSetValues($(this)); }
            });
        },
        offerSetCardsHover: function() {
            // Prevent hover on mobile devices -> avoids confusion on borders
            var _this = this;

            function isTouchDevice() {
                return !!('ontouchstart' in window) || !!('msMaxTouchPoints' in navigator) || !!('maxTouchPoints' in navigator && navigator.maxTouchPoints > 0);
            }

            if (isTouchDevice()) { _this.$radioZones.addClass("no-hover"); }
        },
        offersRefreshAllCardsPrices: function() {
            var _this = this;

            $.each(_this.$pricingTogglers.filter(":checked"), function() { _this.offersPricingTogglersSetValues($(this)); });
        },
        offersSetBasePackPages: function($checkedPack) {
            var _this = this;

            var pagesCount = $checkedPack.data("pages-included");
            _this.$pagesSliderInput.attr("data-base-pack-pages-count", pagesCount);
            _this.$pagesSliderInput.attr("data-user-min-value", pagesCount);
            _this.$pagesCardReccuringPrice.removeAttr("data-quantity");
            _this.$pagesSliderHiddenInput.val(0);
            _this.$pagesSliderInput.val(pagesCount);
            appCustomerSpace.LimitlessPlugins.Slider.init(_this.$html);

            _this.offersRefreshPagesCard();
            _this.offersRefreshAllCardsPrices();
        },
        offersPricingTogglersSetValues: function($input) {
            var _this = this;

            var discountpercentage = parseFloat($input.data("percentage"));
            var $targets           = _this.$html.find(`.${$input.data("pricing-targets")}`);

            if($targets.length == 0) { return false; }

            $.each($targets, function() {
                _this.offersSetPriceForPriceElement($(this), discountpercentage);
            });
        },
        offersSetPriceForPriceElement: function($element, percentage) {
            var initialPrice    = parseInt($element.data("initial-value")) * ($element.attr("data-quantity") ? parseInt($element.attr("data-quantity")) : 1);
            var newPrice        = $element.hasClass("no-percentage") ? initialPrice : Math.floor(initialPrice - (initialPrice * (percentage / 100)));

            if($element.html() == newPrice) { return false; }

            $element.html(newPrice).parent().addClass("fade-in").on("animationend", function() {
                $(this).removeClass("fade-in");
            });;
        },
        offersSetPagesInputsValues: function() {
            var _this = this;

            _this.basePackPagesCount = parseInt(_this.$pagesSliderInput.attr("data-base-pack-pages-count"));
            _this.$pagesPackInfo.find(".pages-count").html(_this.basePackPagesCount);

            var optionsCount = Math.max(0, (parseInt(_this.$pagesSliderInput.val()) - _this.basePackPagesCount) / 5)

            _this.$pagesSliderHiddenInput.val(optionsCount);
        },
        offersPagesEvents: function() {
            var _this = this;

            _this.$pagesSliderInput.on("change", function() {
                _this.offersSetPagesInputsValues();
                _this.offersRefreshPagesCard();
            });
        },
        offersRefreshPagesCard: function() {
            var _this = this;

            _this.$pagesCardPagesCount.html(_this.$pagesSliderInput.val());
            _this.$pagesCardReccuringPrice.attr("data-quantity", _this.$pagesSliderHiddenInput.val());
            _this.$pagesCardOneOffPrice.attr("data-quantity", _this.$pagesSliderHiddenInput.val());

            if(_this.$pagesSliderHiddenInput.val() == 0) {
                _this.$pagesCard.find(".card-body .card-already-included").removeClass("display-none");
                _this.$pagesCard.find(".card-body .card-prices").addClass("display-none");
                _this.$pagesPackInfo.addClass("display-none");
            } else {
                _this.$pagesCard.find(".card-body .card-already-included").addClass("display-none");
                _this.$pagesCard.find(".card-body .card-prices").removeClass("display-none");
                _this.$pagesPackInfo.removeClass("display-none");
            }

            _this.offersRefreshAllCardsPrices();
        },
        // MIGRATION FUNCTIONS
        migrationEvents: function() {
            var _this = this;

            _this.$form.on("submit", function(event) {
                _this.displaySubmitLoader();
                _this.migrationSubmit(event);
            });

            _this.$consentCheckbox.on("change", function() {
                _this.toggleSubmitDisabled($(this).is(":checked"));
            });
        },
        migrationSubmit: function(event) {
            var _this = this;
            event.preventDefault();

            $.ajax({
                url: _this.$form.attr("action"),
                type: "POST",
                data: _this.$form.serialize(),
                success: function(response) {
                    if(response.response == 1) {
                        _this.migrationSynchronisationCheck(1);
                    } else {
                        window.location.href = response.redirect_url
                    }
                }
            });
        },
        migrationSynchronisationCheck: function(attempts) {
            var _this       = this;
            var urlToCheck  = _this.$form.data("after-submit-check-url");

            $.ajax({
                url: urlToCheck,
                type: "GET",
                success: function(response) {
                    attempts++;
                    if(attempts > 15 && response.response != 1) { return window.location.href = response.redirect_url }
                    if(response.response == 1) { return window.location.href = response.redirect_url; }
                    setTimeout(function() { _this.migrationSynchronisationCheck(attempts) }, 1000);
                },
                error: function() {
                    appCustomerSpace.Loader().error({ $container: _this.$form, options: { style: { backdrop: { background: "#FFFFFFCC" } }, text: "Synchronisation des échouée, veuillez contacter un conseiller.", error: { persisted: true } } });
                }
            });
        },
        // PAYMENT FUNCTIONS
        paymentEvents: function() {
            var _this = this;

            appCustomerSpace.Modules.PlatformPaymentIframe.init(_this.$iframeContainer, {
                messageCodesCallback: function(code) {
                    if(code == "101") { _this.$wizardProgress.css("width", "50%"); };
                },
                messageTypesCallback: function(type) {
                    if(type == "SUCCESS") {
                        _this.$wizardProgress.css("width", "100%");
                        _this.toggleSubmitDisabled(true);
                    };
                }
              });
        },
        // SUMMARY FUNCTIONS
        summaryEvents: function() {
            var _this = this;

            _this.$form.on("submit", function() {
                _this.displaySubmitLoader();
            });

            _this.$consentCheckbox.on("change", function() {
                _this.toggleSubmitDisabled($(this).is(":checked"));
            });

            _this.$numberInputs.on("input", function() {
                maxValue = parseInt($(this).attr("max"));
                if(parseInt($(this).val()) > maxValue) { $(this).val(maxValue); }
            });

            _this.$discountRefreshButtons.on("click", function() {
                _this.displaySubmitLoader();
                _this.$consentCheckbox.prop("checked", false);
                _this.$summaryForm.submit();

                return false;
            });

            if(_this.$selectBusinessVoucher.length) {
                _this.$selectBusinessVoucher.on("change", function() {
                    _this.displaySubmitLoader();
                    _this.$consentCheckbox.prop("checked", false);
                    _this.$summaryForm.submit();

                    return false;
                });
            }
        },
        // GENERAL FUNCTIONS
        toggleSubmitDisabled: function(boolean) {
            var _this = this;
            _this.$submitBtnTooltip = _this.$submitBtn.parent();

            if(!_this.$submitBtn.length) { return false; }

            if(boolean) {
                if(_this.$submitBtn.is("a")) { _this.$submitBtnTooltip.removeClass("cursor-not-allowed") }
                _this.$submitBtn.removeAttr("disabled");
                _this.$submitBtnTooltip.addClass("no-tooltip");
            } else {
                if(_this.$submitBtn.is("a")) { _this.$submitBtnTooltip.addClass("cursor-not-allowed") }
                _this.$submitBtn.attr("disabled", "disabled");
                _this.$submitBtnTooltip.removeClass("no-tooltip");
            }

            appCustomerSpace.LimitlessPlugins.Tooltip.init(_this.$html);
        },
        displaySubmitLoader: function() {
            var _this = this;

            _this.$submitBtn.find("i").removeClass("fa-chevron-right").addClass("fa-spinner fa-spin");
            $container = _this.$html.find(".panel.panel-flat");
            appCustomerSpace.Loader().start({ $container: $container, options: { style: { backdrop: { background: "#FFFFFFCC" } } } });
        }
    });

    return MainController;

})(appCustomerSpace.Controllers.Public.MainController);
